import { type Partner } from '@/api/routes/partners/partners.api';
import Button from '@/components/Button';
import { IconLock } from '@/components/icon/tabler/IconLock';
import StatusGate from '@/domain/account-status/components/StatusGate';
import { SUPPORT_WHATSAPP_URL } from '@/domain/account-status/utils';
import { useTranslate } from '@/state/i18n';

interface Props {
  partner: Partner;
}

/** P07: nothing to do in the portal; the partner talks to the team. */
const StatusSuspended = ({ partner }: Props) => {
  const t = useTranslate('domain.account-status.components.StatusSuspended');

  return (
    <StatusGate
      icon={<IconLock color="action" sx={{ fontSize: 44 }} />}
      title={t('title')}
      description={t('description')}
      note={partner.reviewNote ? { label: t('noteLabel'), text: partner.reviewNote } : null}
      actions={
        <Button
          href={SUPPORT_WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
        >
          {t('contact')}
        </Button>
      }
    />
  );
};

export default StatusSuspended;
